// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1qya0yx2 {
  max-width: var(--_18w76bw0);
}
._1qya0yx3 {
  max-width: var(--_18w76bw1);
}
._1qya0yx4 {
  max-width: var(--_18w76bw2);
}
._1qya0yx5 {
  max-width: var(--_18w76bw3);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["._1qya0yx2 {\n  max-width: var(--_18w76bw0);\n}\n._1qya0yx3 {\n  max-width: var(--_18w76bw1);\n}\n._1qya0yx4 {\n  max-width: var(--_18w76bw2);\n}\n._1qya0yx5 {\n  max-width: var(--_18w76bw3);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
